import React, { useState } from 'react';
import { Grid, Box, Link } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

const PricingField = ({ courseData, setCourseData, showIcons, setShowIcons }: any) => {
    const [formValues, setFormValues] = useState({
        price: courseData.price || '',
    });

    const formatCurrency = (value: string) => {
        // Remove any non-numeric characters except for the decimal point
        const numericValue = value.replace(/[^\d.]/g, '');
        return numericValue ? `$${numericValue}` : '';
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let { name, value } = e.target;

        value = formatCurrency(value);
        setFormValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));

        setCourseData((prevContentData: any) => ({
            ...prevContentData,
            price: value.replace('$', ''),
        }));
        setShowIcons((prevState: any) => ({
            ...prevState,
            pricing: value.length > 0,
        }));
    };

    return (
        <Grid display={"flex"} gap={5} flexDirection={"column"} p={{ xs: 2, md: 5 }} mt={{ xs: 3, md: 0 }}>
            <Grid item xs={12} sm={6} gap={1} display={"flex"} flexDirection={"column"}>
                <label
                    htmlFor="price"
                    style={styleSheet.labelText}
                >
                    Price
                </label>
                <Grid display={"flex"} alignItems={"center"} flex={1}>
                    <Box sx={{ flexGrow: 1, display: "flex", gap: 1, alignItems: "center" }}>
                        <CustomTextField
                            name="price"
                            type="text"
                            placeholder='$'
                            sx={{ width: '100%', maxWidth: '654px' }}
                            value={formValues.price}
                            onChange={handleChange}
                        />
                    </Box>

                </Grid>
            </Grid>

        </Grid>
    );
};

export default PricingField;

const styleSheet = {
    labelText: {
        fontWeight: 400, fontSize: "17px", color: "#000000",
    }
}